module.exports = __webpack_public_path__ + "assets/img/29_248_big.07de9d8f.jpg";